import { useTranslation } from '@hotjar/translations';
import { getQuestionLabelAndIcon } from '../utils';
import { useSurveyQuestions } from '../../../hooks/survey/useSurveyQuestions';
import { AdvancedSelect } from '../../common/AdvancedSelectA11y/AdvancedSelect';
import { IconOption } from '../../common/AdvancedSelectA11y/IconOption';
import {
  useSelectedQuestion,
  useSetSelectedQuestion,
} from '../SurveyView/SurveyResultsView/useSelectedQuestion';

export interface QuestionSelectorProps {
  surveyId: number;
  allowAll?: boolean;
  trackingEventName: string;
}

export const QuestionSelector = ({
  surveyId,
  allowAll = false,
  trackingEventName,
}: QuestionSelectorProps): JSX.Element | null => {
  const { t } = useTranslation('feedback', { keyPrefix: 'results' });
  const selectedQuestion = useSelectedQuestion(surveyId, allowAll);

  const { questions } = useSurveyQuestions(surveyId);

  const setSelectedQuestion = useSetSelectedQuestion(surveyId, trackingEventName);

  if (selectedQuestion === undefined || questions === undefined) return null;

  return (
    <AdvancedSelect
      id="selectedQuestion"
      ariaLabel={t('select-a-question')}
      onSelect={(value) => setSelectedQuestion(value)}
      selectedValue={selectedQuestion === 'ALL' ? 'ALL' : selectedQuestion.uuid}
    >
      {allowAll && (
        <IconOption id="all" key="all" value="ALL">
          {t('all-questions')}
        </IconOption>
      )}
      {questions.map(({ uuid, text, type }) => (
        <IconOption icon={getQuestionLabelAndIcon(type).icon} id={uuid} key={uuid} value={uuid}>
          {text}
        </IconOption>
      ))}
    </AdvancedSelect>
  );
};
